import HomePage from "components/Main/HomePage";

function Homepage() {
  return (    
    <HomePage />
  )
}

export default Homepage
